"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _Select = _interopRequireDefault(require("../Select"));

var _TextField = _interopRequireDefault(require("../TextField"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TablePagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TablePagination, _PureComponent);

  function TablePagination() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TablePagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TablePagination)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      goToPage: ''
    });

    _defineProperty(_assertThisInitialized(_this), "onPageChange", function (_ref) {
      var selected = _ref.selected;

      _this.props.onPageChange(selected);
    });

    _defineProperty(_assertThisInitialized(_this), "onPageSizeChange", function (e) {
      e && _this.props.onPageSizeChange(e.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onGoToPageChange", function (e) {
      _this.setState({
        goToPage: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGoToPageSubmit", function (e) {
      if (e.key === 'Enter') {
        var parsedPage = parseInt(_this.state.goToPage, 10);

        if (!Number.isNaN(parsedPage)) {
          _this.props.onPageChange(parsedPage - 1);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getPageSizeOptions", (0, _memoizeOne["default"])(function (pageSizeOptions) {
      return pageSizeOptions.map(function (pageSize) {
        return {
          label: pageSize,
          value: pageSize
        };
      });
    }));

    return _this;
  }

  _createClass(TablePagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          page = _this$props.page,
          pages = _this$props.pages,
          pageSize = _this$props.pageSize,
          pageSizeOptions = _this$props.pageSizeOptions,
          showPageJump = _this$props.showPageJump,
          showPageSizeOptions = _this$props.showPageSizeOptions;
      var goToPage = this.state.goToPage;

      if (pages < 1) {
        return null;
      }

      var pageSizeSelect = showPageSizeOptions ? _react["default"].createElement(_Select["default"], {
        clearable: false,
        label: "Per Page",
        options: this.getPageSizeOptions(pageSizeOptions),
        value: pageSize,
        onChange: this.onPageSizeChange
      }) : null;
      var pageJumpField = showPageJump ? _react["default"].createElement(_TextField["default"], {
        label: "Go To",
        value: goToPage,
        onChange: this.onGoToPageChange,
        onKeyDown: this.onGoToPageSubmit
      }) : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, 'rt-pagination')
      }, pageSizeSelect, pages > 1 && pageJumpField, pages > 1 && _react["default"].createElement(_Pagination["default"], {
        initialPage: page,
        forcePage: page,
        pageCount: pages,
        onPageChange: this.onPageChange
      }));
    }
  }]);

  return TablePagination;
}(_react.PureComponent);

exports["default"] = TablePagination;
TablePagination.propTypes = {
  className: _propTypes["default"].string,
  page: _propTypes["default"].number.isRequired,
  pages: _propTypes["default"].number.isRequired,
  pageSize: _propTypes["default"].number.isRequired,
  pageSizeOptions: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  showPageJump: _propTypes["default"].bool,
  showPageSizeOptions: _propTypes["default"].bool,
  onPageChange: _propTypes["default"].func.isRequired,
  onPageSizeChange: _propTypes["default"].func.isRequired
};